import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'formatLocaleDateTimeFull',
})
export class FormatLocaleDateTimeFullPipe implements PipeTransform {
	private optionsToConvertDate = {
		weekday: 'long',
		year: 'numeric',
		month: 'long',
		day: 'numeric',
	};

	transform(value: any, ...args: any[]): any {
		const date = new Date(value + ' UTC');
		return date.toLocaleString(navigator.language, this.optionsToConvertDate as any);
	}
}
